import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {TabbedFilterGroup, TabbedFilterItem, TabbedFilterItemValue} from '../../TABBED_FILTERS_CONFIG';
import {DomainService} from '../../../../../services/domain-service';
import {AppService} from '../../../../../services/app-service';
import {ActivatedRoute} from '@angular/router';
import {DropdownSelectItem} from '../../DropdownSelectItem';
import {SearchFilterItem} from '../../SearchFilterItem';

declare var jQuery;

@Component({
  selector: 'app-side-filter-item',
  templateUrl: './side-filter-item.component.html',
  styleUrls: ['./side-filter-item.component.scss']
})
export class SideFilterItemComponent implements OnInit {

  @Input() item: TabbedFilterItem;
  @Input() tabbedGroup: TabbedFilterGroup;
  @Input() currentConfig: any;
  @Input() selectedFilterValues: TabbedFilterItemValue[];
  @Input() cannedreports: Array<any>;
  @Input() loadingData: boolean;
  @Input() noFacets: boolean;
  @Input() facets: any;
  @Input() currentCannedReportUpdater: EventEmitter<any>;
  @Input() importedFileNameUpdater: EventEmitter<string>;
  @Input() facetsUpdater: EventEmitter<any>;
  @Input() showOptionsInvoker: EventEmitter<any>;
  @Input() routeFilterValuesUpdater: EventEmitter<any>;
  @Input() onDropdownFilterSelectInvoker: EventEmitter<any>;

  constructor(private _domainService: DomainService,
              private _appService: AppService,
              private _route: ActivatedRoute) { }

  ngOnInit() {
    this.onDropdownFilterSelectInvoker.subscribe(value => {
      this.onDropdownFilterSelect(value.tabbedFilterItem, value.option, value.event);
    });
  }

  close(event) {
    jQuery(event.target).parents('.level2.collapse').parents('.card.level2').find('[data-toggle="collapse"]').click();
  }

  closeWithDelay(event) {
    setTimeout(() => {
      this.close(event);
    }, 300);
  }

  isSelectedFilter(tabbedFilterItem: TabbedFilterItem, option: DropdownSelectItem) {
    let isFound = null;
    if (this.selectedFilterValues && this.selectedFilterValues.length > 0) {
      isFound = this.selectedFilterValues.filter(value => value.param === tabbedFilterItem.param && value.value === option.value);
    }

    if (isFound && isFound.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  onDropdownFilterSelect(tabbedFilterItem: TabbedFilterItem, option: DropdownSelectItem, event: any) {
    if (event) {
      event.stopPropagation();
    }

    if (!this.loadingData) {
      if (!this.noFacets && (!this.facets || !this.facets[tabbedFilterItem.param] || !this.facets[tabbedFilterItem.param][option.value])) {

      } else {
        let found = false;
        const filterValues = [];
        const oValue = option.value;
        const oText = option.text;
        this.selectedFilterValues.forEach(filterValue => {
          if (tabbedFilterItem.multiple) {
            if (filterValue.param === tabbedFilterItem.param && filterValue.value === oValue) {
              found = true;
            } else {
              filterValues.push(filterValue);
            }
          } else {
            if (filterValue.param === tabbedFilterItem.param) {
              if (filterValue.value !== oValue) {
                filterValue.value = oValue;
                filterValue.valueLabel = oText;
                filterValues.push(filterValue);
              }
              found = true;
            } else {
              filterValues.push(filterValue);
            }
          }
        });
        if (!found) {
          filterValues.push(
            {
              param: tabbedFilterItem.param,
              value: oValue,
              valueLabel: oText,
              label: tabbedFilterItem.label
            }
          );
        }
        this._appService.excludeFacetParam = tabbedFilterItem.param;

        // TODO: Call routeWithFilterValuesEvent
        // this.routeWithFilterValues(filterValues);
        this.routeFilterValuesUpdater.emit(filterValues);
      }
    }
    this.close(event);
  }

  onRangeChanged(tabbedFilterItem: TabbedFilterItem, option: SearchFilterItem) {
    if (!this.loadingData) {
      let found = false;
      const filterValues = [];
      const oValue = option.values[0];
      const oText = option.text;
      this.selectedFilterValues.forEach(filterValue => {
        if (tabbedFilterItem.multiple) {
          if (filterValue.param === tabbedFilterItem.param && filterValue.value === oValue) {
            found = true;
          } else {
            filterValues.push(filterValue);
          }
        } else {
          if (filterValue.param === tabbedFilterItem.param) {
            if (filterValue.value !== oValue) {
              filterValue.value = oValue;
              filterValue.valueLabel = oText;
              filterValues.push(filterValue);
            }
            found = true;
          } else {
            filterValues.push(filterValue);
          }
        }
      });

      if (!found) {
        filterValues.push(
          {
            param: tabbedFilterItem.param,
            value: option.values[0],
            valueLabel: option.text,
            label: tabbedFilterItem.label
          }
        );
      }
      this._appService.excludeFacetParam = tabbedFilterItem.param;
      this.routeFilterValuesUpdater.emit(filterValues);
      this.closeWithDelay(option.event);
    }

  }

  showOptions(tabbedFilterItem: TabbedFilterItem) {
    this.showOptionsInvoker.emit({tabbedFilterItem: tabbedFilterItem});
  }

}
